import { createStyles, makeStyles, Theme, Tooltip } from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';

import { colorPalette, spacings, TextSizesEnum } from '../../../theme';
import { formatDisplayedDate, formatFullDate } from '../../../utils/commons';
import { PlexTypography } from '../../shared/primitives/PlexTypography';

type Props = {
  className?: string;
  prefix?: string;
  date: Date;
  size?: TextSizesEnum;
};

export function PostDate(props: Props): React.ReactElement {
  const { date, prefix = '', className, size = TextSizesEnum.Small } = props;
  const classes = useStyles();

  return (
    <Tooltip title={formatFullDate(new Date(date))}>
      <PlexTypography
        className={classNames(classes.root, className)}
        text={`${prefix}${formatDisplayedDate(new Date(date))}`}
        size={size}
      />
    </Tooltip>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      color: colorPalette.purpleGray._300,
      fontWeight: 500,
      marginLeft: spacings.xsmall,
    },
  })
);
